import { Injectable, inject } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment } from '@angular/router';
import { LocaleService } from '../services/locale.service';

/**
 * Guard that only matches when the first URL segment is a supported locale code.
 * Used with canMatch to enable locale-prefixed routing (/en/..., /vi/...).
 */
@Injectable({ providedIn: 'root' })
export class LocalePrefixGuard implements CanMatch {
  private localeService = inject(LocaleService);

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    const locale = segments[0]?.path;
    const supportedLocales = this.localeService.supportedLocales.map(l => l.code);

    if (supportedLocales.includes(locale)) {
      if (this.localeService.getCurrentLocale() !== locale) {
        this.localeService.setLocale(locale);
      }
      return true;
    }

    return false;
  }
}
